function activateSelectors(selector, typeofEventListener) {
    var elements = document.querySelectorAll(selector);
    for (var i = 0; i < elements.length; i++) {
        var genericEventListener = new typeofEventListener(elements[i]);
        try {
            genericEventListener.listen();
        } catch (error) {
            console.error(error);
        }
    }
}
